<template>
  <div class="device-all">
    <div class="state-legend">
      <div :span="3" v-for="(ds, i) in deviceState" :key="i">
        <span :class="ds.value | stateClass(true)" class="state-block"></span>
        <span>{{ ds.label | translateTo('device.state') }}</span>
      </div>
    </div>
    <div class="device-list">
      <scrollbar type="thin">
        <div slot="scrollbar">
          <div v-for="(node, i) in deviceList" :key="i">
            <el-breadcrumb style="padding: 15px" separator-class="el-icon-arrow-right">
              <el-breadcrumb-item v-for="office in node.childNodes" :key="office.id">
                {{ office.name }}
              </el-breadcrumb-item>
            </el-breadcrumb>
            <div class="device-row">
              <div class="device-col" v-for="(v, i) in node.leafNodes" :key="i">
                <div
                  class="single-device"
                  @click="chooseSn(v.sn, v.state, v.deviceType, v.runMode)"
                  :class="{ 'is-active': checkedSn === v.sn }"
                >
                  <span :class="v.state | stateClass(true)" :title="`设备名称: ${v.name}`">
                    {{ v.name }}
                  </span>
                  <span :class="v.state | stateClass(true)" :title="`设备号: ${v.sn}`">
                    {{ v.sn }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </scrollbar>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import ctt from '@/utils/const';
import { pointState, deviceState } from '@/utils/dict';
import { isArray } from '@/utils/is';

function treeDataRecu(count, result, arr, childNodes = []) {
  const leafNodes = [];
  let copyChildNodes;
  count++;
  if (isArray(arr)) {
    arr.forEach(e => {
      copyChildNodes = JSON.parse(JSON.stringify(childNodes));
      if (e.nodeType === 1) {
        copyChildNodes.push({
          name: e.name,
          id: e.id
        });
        treeDataRecu(count, result, e.children, JSON.parse(JSON.stringify(copyChildNodes)));
      } else {
        if (count === 1) {
          result.push({ childNodes: [{ name: e.name, id: e.id }], leafNodes: [] });
        } else {
          leafNodes.push(e);
        }
      }
    });
  }
  if (count !== 1 && leafNodes.length > 0) {
    result.push({ childNodes: copyChildNodes, leafNodes });
  }
}

export default {
  name: 'DeviceAll',
  data() {
    return {
      deviceState
    };
  },
  computed: {
    ...mapState('socket', ['devicesSourseMap']),
    deviceList() {
      const count = 0;
      const result = [];
      treeDataRecu(count, result, this.$store.state.socket.deviceTree);
      return result;
    },
    checkedSn() {
      return this.$route.params.sn;
    }
  },
  methods: {
    chooseSn(sn, state, deviceType, runMode) {
      if (
        runMode === ctt.MONITOR_DEVICE &&
        (state === undefined || state === ctt.POINT_STATE_UNCONNECT)
      ) {
        this.$message({ type: 'info', message: pointState[state] });
      } else {
        if (sn !== this.$route.params.sn) {
          this.$router.push({
            name: 'Realdata',
            params: { sn, deviceType }
          });
        }
      }
    }
  }
};
</script>

<style lang="scss">
.light {
  .device-all {
    .state-legend {
      color: var(--text-color1);
    }

    .device-col {
      .single-device {
        background-color: transparent;
        border: 1px solid #ccc;
        border-radius: 6px;
      }
    }
  }
}

.device-all {
  height: 100%;
  .state-legend {
    padding: 15px;
    display: flex;

    > div {
      margin-right: 15px;
      display: flex;
      align-items: center;
      .state-block {
        display: inline-block;
        height: 15px;
        width: 15px;
        margin-right: 5px;
        @include state-bgstyle;
      }
    }
  }
  .device-list {
    height: calc(100% - 60px);
  }
  .device-row {
    display: flex;
    justify-content: flex-start;
    overflow-x: hidden;
    flex-wrap: wrap;
  }
  .device-col {
    width: 20%;
    max-width: 200px;
    padding: 0 15px;
    box-sizing: border-box;
    .single-device {
      background-color: var(--device-card-bg);
      height: 60px;
      margin-bottom: 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      cursor: pointer;
      span {
        display: inline-block;
        @include state-textstyle;
        width: 80%;
        text-align: center;
        @include ellipsis-style;
      }
      &.is-active {
        border: 1px solid var(--device-active-border);
      }
    }
  }
}
</style>
